<template>
  <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium" :class="classes">
      <slot></slot>
  </span>
</template>

<script>
export default {
    name: "Badge",
    props: {
        badgeType: String,
    },
    computed: {
        classes() {
            switch (this.badgeType) {
                case 'success':
                    return 'bg-success-200 text-success-900';
                    break;
                case 'warning':
                    return 'bg-warning-200 text-warning-900';
                    break;
                case 'info':
                    return 'bg-info-200 text-info-900';
                    break;
                case 'danger':
                    return 'bg-danger-200 text-danger-900';
                    break;
                default:
                    return 'bg-gray-200 text-gray-900';
            }
        }
    }
}
</script>

<style scoped>

</style>
